import styled from 'styled-components'

import { baseBreadcrumbStyles } from './BaseBreadcrumbStyles'

export const BreadcrumbCrumbStyled = styled.span`
  ${baseBreadcrumbStyles}
`
